// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"60":"d9cf47f4","317":"28211d6e","342":"77edc8cb","740":"21618f68","791":"9f920d95","989":"825e68d5"}[chunkId] + ".chunk.js";
};